import React, { useEffect, useState } from 'react';
import ModalContainer from '../../components/ModalContainer.jsx';
import { useLocation, useNavigate } from 'react-router-dom';
import Assessment from './serviceDetailsAdditionFields/Assessment.jsx';
import { convertDateToJalaali } from '../../utils/convertDate.js';
import Status from './additionFields/Status.jsx';
import Supply from './serviceDetailsAdditionFields/Supply.jsx';
import { base_api_url } from '../../services/httpService.js';
import { Button } from '@mui/material';
import { fileDownloaderWithName, fileDownloaderWithoutFormat } from '../../utils/fileDownloader.js';
import DataList from '../../components/DataList.jsx';
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import { getSingleServiceDataService } from '../../services/servicesServices.js';
import Alert from '../../utils/Alert.js';


const filesInfo = [
    {
        text: "فایل مشتری",
        urlField: "file",
        fileURL: (code) => `${base_api_url}/shop_admin/get_customer_file/${code}/`,
        fileName: null,
        convertToString: false,
        withoutFormat: true
    },
    {
        text: "فایل output",
        urlField: "output_file",
        fileURL: (code) => `${base_api_url}/shop_admin/get_output_file/${code}/`,
        fileName: null,
        convertToString: false,
        withoutFormat: false
    },
    {
        text: "فایل alert",
        urlField: "alert_file",
        fileURL: (code) => `${base_api_url}/shop_admin/get_alert_file/${code}/`,
        fileName: null,
        convertToString: false,
        withoutFormat: false
    },
    {
        text: "فایل error",
        urlField: "error_file",
        fileURL: (code) => `${base_api_url}/shop_admin/get_error_file/${code}/`,
        fileName: null,
        convertToString: false,
        withoutFormat: false
    },
    {
        text: "فایل bill",
        urlField: "bill_file",
        fileURL: (code) => `${base_api_url}/shop_admin/get_bill_file/${code}/`,
        fileName: null,
        convertToString: false,
        withoutFormat: false
    },
    {
        text: "فایل step",
        urlField: "map_file",
        fileURL: (code) => `${base_api_url}/shop_admin/get_map_file/${code}/`,
        fileName: "uploaded_mfile.stp",
        convertToString: false,
        withoutFormat: false
    },
    {
        text: "فایل nx",
        urlField: "mfile",
        fileURL: (code) => `${base_api_url}/shop_admin/get_mfile/${code}/`,
        fileName: null,
        convertToString: false,
        withoutFormat: false
    },
    {
        text: "فایل map",
        urlField: "map",
        fileURL: (code) => `${base_api_url}/shop_admin/get_local_customer_file/${code}/`,
        fileName: null,
        convertToString: false,
        withoutFormat: true
    }
];

const filesRows = filesInfo.map(item => ({
    field: null,
    text: item.text,
    element: (serviceData) => {
        return (
            <>
                {item.withoutFormat ? (
                    <Button
                        variant="contained"
                        onClick={() => fileDownloaderWithoutFormat(item.fileURL(serviceData.code))}
                    >
                        دانلود
                        <span className="ms-1">
                            <DownloadRoundedIcon />
                        </span>
                    </Button>

                ) : (

                    <Button
                        variant="contained"
                        onClick={() => fileDownloaderWithName(item.fileURL(serviceData.code), item.fileName, item.convertToString)}
                    >
                        دانلود
                        <span className="ms-1">
                            <DownloadRoundedIcon />
                        </span>
                    </Button>
                )
                }
            </>
        );
    }
}));


const ServiceDetails = () => {
    const [serviceData, setServiceData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const location = useLocation();
    const navigate = useNavigate();

    const serviceRows = [
        {
            field: "code",
            text: "کد سرویس"
        },
        {
            field: null,
            text: "وضعیت سرویس",
            element: (rowData) => <Status rowData={rowData} />
        },
        {
            field: null,
            text: "قیمت واحد",
            element: (serviceData) => <span>{serviceData.unit_price && serviceData.unit_price.toLocaleString()}</span>
        },
        {
            field: "quantity",
            text: "تعداد"
        },
        {
            field: null,
            text: "قیمت کل",
            element: (serviceData) => <span>{serviceData.total_price && serviceData.total_price.toLocaleString()}</span>
        },
        {
            field: "weight",
            text: "وزن"
        },
        {
            field: null,
            text: "تاریخ ایجاد سرویس",
            element: (serviceData) => <span className={!serviceData.created_at ? "text-red-500" : ""}>{serviceData.created_at ? convertDateToJalaali(serviceData.create_date) : "مشخص نشده"}</span>
        },
        {
            field: null,
            text: "تاریخ پذیرش سرویس",
            element: (serviceData) => <span className={!serviceData.accept_date ? "text-red-500" : ""}>{serviceData.accept_date ? convertDateToJalaali(serviceData.accept_date) : "مشخص نشده"}</span>
        },
        {
            field: "preparation_time",
            text: "مدت آماده سازی سرویس (بر حسب روز)",
        },
        {
            field: null,
            text: "تاریخ آماده سازی سرویس",
            element: (serviceData) => <span className={!serviceData.preparation_date ? "text-red-500" : ""}>{serviceData.preparation_date ? convertDateToJalaali(serviceData.preparation_date) : "مشخص نشده"}</span>
        },
        {
            field: "expire_time",
            text: "مدت انقضای سرویس (بر حسب روز)",
        },
        {
            field: null,
            text: "تاریخ انقضای سرویس",
            element: (serviceData) => <span className={!serviceData.expire_date ? "text-red-500" : ""}>{serviceData.expire_date ? convertDateToJalaali(serviceData.expire_date) : "مشخص نشده"}</span>
        },
        {
            field: null,
            text: "برنامه",
            element: (serviceData) => <span>{serviceData.plan?.slug}</span>
        },
        {
            field: null,
            text: "ماده اولیه",
            element: (serviceData) => <span>{serviceData.custom_material || `${serviceData.material?.persian_class} (${serviceData.material?.id})`}</span>
        },
        {
            field: null,
            text: "تهیه کننده ماده اولیه",
            element: (serviceData) => <Supply serviceData={serviceData} />
        },
        {
            field: null,
            text: "توضیحات مشتری",
            element: (serviceData) => <span className={!serviceData.customer_description ? "text-red-500" : ""}>{serviceData.customer_description || "ندارد"}</span>
        },
        {
            field: null,
            text: "توضیحات ادمین",
            element: (serviceData) => <span className={!serviceData.admin_description ? "text-red-500" : ""}>{serviceData.admin_description || "ندارد"}</span>
        },
        {
            field: null,
            text: "نوع بررسی",
            element: (serviceData) => <Assessment serviceData={serviceData} />
        },
        ...filesRows
    ];

    const handleGetServiceData = async (code) => {
        setIsLoading(true);
        try {
            const response = await getSingleServiceDataService(code);
            if (response.status === 200) {
                setServiceData(response.data);
            }
        } catch (error) {
            Alert(`خطا ${error.response?.status || ""}!`, "در دریافت اطلاعات سرویس مشکلی رخ داده است!\nلطفاً مجدداً تلاش کنید.", "error");
            return navigate(-1)
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (!location.state) {
            return navigate(-1);
        }
        handleGetServiceData(location.state.code);
    }, []);

    return (
        <ModalContainer
            alwaysOpen={true}
            fullscreen={false}
            title={`سرویس "${location.state?.code}"`}
        >
            <DataList
                listData={serviceData}
                listRowsTitles={serviceRows}
                isLoading={isLoading}
            />
        </ModalContainer>
    );
}

export default ServiceDetails;
